import { EditDialog, Select, Switch, Text, Button } from '@104ha/base-ui';
import { Col } from '../../components/col';
import { FormGroup, Label } from '../../components/form';
import { accountMaxText, dialogHeight, dialogWidth, formError } from './const';
import { IPV4, IPV6 } from '../../constant/regex';
import { customAlphabet } from 'nanoid';

const nanoid = customAlphabet('1234567890QAZWSXEDCRFVTGBYHNUJMIKOLP', 40);

const inputs = {
	userAccount: null,
	userName: null,
	pwd: null,
	rePwd: null,
	userIpType: null,
	userIp: null,
	accountStatus: null,
	authMode: null,
	userToken: null,
};

type Keys = keyof typeof inputs;

class EditAccountDialog extends EditDialog<{ id?: number }> {
	static defaultProps = {
		...EditDialog.defaultProps,
		title: '編輯API使用者連接帳號',
		width: dialogWidth,
		height: dialogHeight,
		api: '/api/manage/privilege/account/update',
		errCode: formError,
		successMsg: '編輯帳號完成',
		okText: '確定修改',
	};

	state: {
		ipType: 1 | 2;
		data: any;
		authMode: 1 | 2;
		userToken: '';
		accountStatus: 3 | 4;
	} = {
		...this.state,
		ipType: 1,
		authMode: 1,
		userToken: '',
		accountStatus: 3,
	};

	inputs: {
		[key in Keys]?: {
			getValue: () => any;
			setState: (params: any) => any;
		} | null;
	} = inputs;

	validate() {
		let v = super.validate();
		if (!v) return v;

		const { userIp, userIpType } = this.inputs;
		const userIpTypeValue = userIpType?.getValue();

		let ipValidate = true;
		let userTokenValidate = true;
		let ips = (userIp?.getValue() || '').split(';');
		const isEmptyIpList = ips.length === 1 && ips[0] === '';

		if (this.state.authMode === 1 && isEmptyIpList) return v;

		if (userIpTypeValue === 1) {
			ipValidate = ips.findIndex((ip: string) => !IPV4.test(ip)) < 0;
		}

		if (userIpTypeValue === 2) {
			ipValidate = ips.findIndex((ip: string) => !IPV6.test(ip)) < 0;
		}

		if (!ipValidate) {
			userIp?.setState({ error: 'IP格式錯誤' });
		}

		return v && ipValidate;
	}

	setValues(inputs: { [key in Keys]?: any }) {
		this.setState({ ipType: inputs.userIpType, authMode: inputs.authMode, userToken: inputs.userToken }, () => {
			super.setValues(inputs);
		});
	}

	getValues() {
		const values = super.getValues();
		return {
			...values,
			authMode: this.state.authMode,
			userToken: this.state.userToken,
			accountStatus: values.accountStatus === 1 ? 3 : 4,
		};
	}

	renderBody() {
		return (
			<>
				<FormGroup>
					<Label required>API登入帳號</Label>
					<Col span={16}>
						<Text
							{...{
								ref: (ele: any) => (this.inputs.userAccount = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>帳號名稱</Label>
					<Col span={16}>
						<Text
							{...{
								ref: (ele: any) => (this.inputs.userName = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>API串接模式</Label>
					<Label>{this.state.authMode === 1 ? 'Token串接模式 ' : 'API金鑰模式 '}</Label>
				</FormGroup>
				<FormGroup>
					<Label>連接IP位置限制</Label>
					<Col span={16}>
						<Col span={8}>
							<Select
								ref={(ele: any) => (this.inputs.userIpType = ele)}
								data={{ 1: 'IPV4', 2: 'IPV6' }}
								initValue={1}
								onUpdate={(v) => {
									this.setState({ ipType: v });
								}}
							></Select>
						</Col>
						<Col>
							<Text
								{...{
									ref: (ele: any) => (this.inputs.userIp = ele),
									placeholder:
										this.state.ipType === 1
											? 'ex. 192.168.0.1;192.168.0.*'
											: 'ex: ffff:ffff:ffff:ffff:ffff:ffff:ffff:ffff',
									validate: {
										required: this.state.authMode === 2,
									},
								}}
							/>
						</Col>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label>帳號狀態</Label>
					<Col>
						<Switch ref={(ele: any) => (this.inputs.accountStatus = ele)}></Switch>
					</Col>
				</FormGroup>
				{this.state.authMode === 2 ? (
					<>
						<FormGroup>
							<Label required>金鑰</Label>
							<Col span={3}>
								<Button.One
									onClick={() => {
										const userToken = nanoid();
										this.setState({ userToken });
									}}
								>
									產生
								</Button.One>
							</Col>
							<Col span={13}>
								<p style={{ wordBreak: 'break-all' }}>{this.state.userToken}</p>
							</Col>
						</FormGroup>
					</>
				) : null}
			</>
		);
	}
}
export { EditAccountDialog };
